import { APPROVE_DRIVER_DOCUMENTS } from "../../routes";
import customAxios from "../../customAxios";

const approveDriverDocuments = async (driverId: string) => {
  try {
    return (
      await customAxios.put(APPROVE_DRIVER_DOCUMENTS + "/" + driverId, {
        approve: true,
      })
    ).data;
  } catch (error: unknown) {
    console.error({ APPROVE_DRIVER_DOCUMENTS: error });
    return false;
  }
};

export default approveDriverDocuments;
